/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_UndoInputs */

const en_knp_terms_undo = /** @type {(inputs: Knp_Terms_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const fr_knp_terms_undo = /** @type {(inputs: Knp_Terms_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const de_knp_terms_undo = /** @type {(inputs: Knp_Terms_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückgängig machen`)
};

const it_knp_terms_undo = /** @type {(inputs: Knp_Terms_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfare`)
};

const ru_knp_terms_undo = /** @type {(inputs: Knp_Terms_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменить`)
};

const es_knp_terms_undo = /** @type {(inputs: Knp_Terms_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshacer`)
};

const zh_cn2_knp_terms_undo = /** @type {(inputs: Knp_Terms_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撤销`)
};

const ja_knp_terms_undo = /** @type {(inputs: Knp_Terms_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元に戻す`)
};

const hi_knp_terms_undo = /** @type {(inputs: Knp_Terms_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ववत`)
};

const pt_pt2_knp_terms_undo = /** @type {(inputs: Knp_Terms_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desfazer`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Knp_Terms_UndoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_undo = /** @type {((inputs?: Knp_Terms_UndoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_UndoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_undo(inputs)
	if (locale === "de") return de_knp_terms_undo(inputs)
	if (locale === "it") return it_knp_terms_undo(inputs)
	if (locale === "ru") return ru_knp_terms_undo(inputs)
	if (locale === "es") return es_knp_terms_undo(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_undo(inputs)
	if (locale === "ja") return ja_knp_terms_undo(inputs)
	if (locale === "hi") return hi_knp_terms_undo(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_undo(inputs)
	return en_knp_terms_undo(inputs)
});